import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Terms() {
    return (
        <LegalPage
            slug="terms"
            eyebrow="Legal — 02"
            titleLeft="Terms of"
            titleAccent="Service."
            counterpart={{ to: "/privacy", label: "Privacy Policy" }}
        />
    );
}
